const PageHeader = function (settings) {
	"use strict";

	const _self = this;
	const _settings = {};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$el = document.querySelector(_settings.el);
	}

	function bindEvents() {
		window.addEventListener("scroll", handleScroll);
	}

	function handleScroll() {
		if (window.scrollY > 150) {
			_settings.$el.classList.add(_settings.scrollClass);
		} else {
			_settings.$el.classList.remove(_settings.scrollClass);
		}
	}

	function init() {
		cacheDom();
		bindEvents();

		handleScroll();

		return _self;
	}

	return init();
};

export { PageHeader };
